import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-[#E5E2D9] bg-[#F9F7F3]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-10 grid gap-8 md:grid-cols-4">
        <div>
          <img src="/afripantry-logo.png" alt="AfriPantry" className="h-7 w-auto mb-3" />
          <p className="text-xs text-[#5C5C54] leading-relaxed">
            The UK's trusted marketplace for African groceries. Shop verified vendors from Lagos to Nairobi, delivered to your door.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold tracking-wider uppercase text-[#1A1A18] mb-3">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-[#5C5C54] hover:text-[#A94438]">Marketplace</Link></li>
            <li><Link to="/vendors" className="text-[#5C5C54] hover:text-[#A94438]">Vendors</Link></li>
            <li><Link to="/products" className="text-[#5C5C54] hover:text-[#A94438]">All Products</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold tracking-wider uppercase text-[#1A1A18] mb-3">For Business</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/become-vendor" className="text-[#5C5C54] hover:text-[#A94438]">Become a vendor</Link></li>
            <li><a href="https://wa.me/447979127731" target="_blank" rel="noopener noreferrer" className="text-[#5C5C54] hover:text-[#A94438]">WhatsApp support</a></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold tracking-wider uppercase text-[#1A1A18] mb-3">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" data-testid="footer-terms-link" className="text-[#5C5C54] hover:text-[#A94438]">Terms of Service</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-[#5C5C54] hover:text-[#A94438]">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E2D9] py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#5C5C54]">
          <span>© {new Date().getFullYear()} AfriPantry. All rights reserved.</span>
          <span>Made with love for the African diaspora in the UK.</span>
        </div>
      </div>
    </footer>
  );
}
